import React, { useState } from "react"

import Button from "@mui/material/Button"
import Menu from "@mui/material/Menu"
import MenuItem from "@mui/material/MenuItem"

export function BasicMenu({
  title,
  options,
  chooseOption,
  withIcon,
  className,
}) {
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  function sendData(item) {
    chooseOption(item)
    handleClose()
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <div className={`flex items-center justify-end bg-inherit`}>
      <Button
        onClick={handleClick}
        endIcon={withIcon}
        size='small'
        sx={{
          paddingTop: "5px",
          minWidth: "30px",
          fontSize: "14px",
          color: "primary",
          boxShadow: "none",
          "&:hover": {
            bgcolor: "main",
          },
          "@media (max-width: 500px)": {
            fontSize: "12px",
          },
        }}
      >
        <span className={`font-medium ${className}`}>{title}</span>
      </Button>
      <Menu
        id='basic-menu'
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        {options.map((item, index) => {
          if (item.separator) {
            return (
              <hr
                key={`separator-${index}`}
                style={{
                  margin: "4px 0",
                  border: "none",
                  borderTop: "1px solid #e0e0e0",
                }}
              />
            )
          }
          const IconComponent = item.icon
          return (
            <MenuItem
              key={index}
              sx={{
                fontSize: "14px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
              onClick={() => sendData(item.title)}
            >
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                {IconComponent && (
                  <IconComponent
                    sx={{
                      fontSize: "20px",
                      color: "#737C86",
                    }}
                  />
                )}
                <span>{item.title}</span>
              </div>
              {item.badge && (
                <span
                  style={{
                    backgroundColor:
                      item.badge === "Pro" ? "#14213D" : "#0E4711FF",
                    color: "white",
                    padding: "2px 8px",
                    borderRadius: "5px",
                    fontSize: "12px",
                    fontWeight: "400",
                    marginLeft: "8px",
                  }}
                >
                  {item.badge}
                </span>
              )}
            </MenuItem>
          )
        })}
      </Menu>
    </div>
  )
}
